<template>
  <div class="cart-container">
    <el-popover placement="bottom" trigger="click" v-model="visible">
      <el-table
        :data="carts"
        :row-style="{height:'36px'}"
        stripe
        border
        size="small"
        :header-cell-style="{background:'#D7D7D7',color:'#000'}"
      >
        <el-table-column width="160" property="code" label="Item Code"></el-table-column>
        <el-table-column width="300" property="name" label="Item Name"></el-table-column>
        <el-table-column width="50" property="qty" label="QTY." align="right"></el-table-column>
        <el-table-column width="80" label="Action" align="center">
          <template v-slot="scope">
            <el-button
              round
              size="mini"
              type="text"
              :style="{color: 'green'}"
              @click="deleteItem(scope.row.id)"
            >Delete</el-button>
          </template>
        </el-table-column>
        <div slot="empty"><span class="popover-table-empty-text">No Data</span></div>
      </el-table>
      <div>
        <div class="total-qty-container">Total&nbsp;:&nbsp;&nbsp;&nbsp;{{totalQty}}</div>
        <el-button v-show="cartsCnt"  type="text" size="mini" @click="clearCart">Clear All</el-button>
      </div>
      <el-button slot="reference" class="in-cart-btn">
        In-Cart Items:&nbsp;&nbsp;
        <strong>{{cartsCnt}}</strong>
        <transition name="fade"><div class="badge" v-if="badgeShow"></div></transition>
      </el-button>
    </el-popover>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'CartSimple',
  data () {
    return {
      visible: false,
      badgeShow: false
    }
  },
  computed: {
    ...mapState('cart', [
      'carts'
    ]),
    ...mapGetters('cart', [
      'cartsCnt',
      'totalQty'
    ])
  },
  methods: {
    ...mapActions({
      clearCart: 'cart/clearCart',
      deleteItem: 'cart/deleteFromCart'
    })
  },
  watch: {
    totalQty: function () {
      this.badgeShow = true
      setTimeout(() => { this.badgeShow = false }, 350)
    }
  }
}
</script>

<style lang="scss" scoped>
.in-cart-btn {
  height: 32px;
  // margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
  background-color: transparent;
  border-color: #2d8cf0;
  color: #2d8cf0;
}
.total-qty-container {
  display: inline-block;
  width: 510px;
  box-sizing: border-box;
  margin-top: 14px;
  margin-right: 20px;
  padding-right: 10px;
  text-align: right;
  font-size: 12px;
  font-weight: bold;
}
.cart-container {
  position: relative;
}
.badge {
  background-color: #f56c6c52;
  display: inline-block;
  border-radius:4px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 0px;
  right: 0px;
  // transition: all 1s ease;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>
